import React from 'react'

export default function SubNavbar({ tabs = [], activeTab, onTabChange, className = '' }) {
  return (
    <div className={`flex border-b border-gray-200 bg-white rounded-xl px-4 pt-2 gap-2 mb-6 ${className}`}>
      {tabs.map((tab) => {
        const id = typeof tab === 'string' ? tab : tab.id
        const label = typeof tab === 'string' ? tab : tab.label
        const isActive = activeTab === id
        return (
          <button
            key={id}
            type="button"
            onClick={() => onTabChange(id)}
            className={`px-5 py-3 text-sm font-semibold border-b-2 transition-all cursor-pointer ${isActive
                ? 'border-blue-600 text-blue-600 font-bold'
                : 'border-transparent text-gray-500 hover:text-gray-900'
              }`}
          >
            {label}
          </button>
        )
      })}
    </div>
  )
}
